export default {
    baseStyle: {
        heroBannerContainer: {
            w: '100%',
            m: '0 auto',
        },
        heroBannerMain: {
            w: '100%',
            position: 'relative',
        },
        heroBannerVideo: {
            position: {lg: 'absolute'},
            width: '100%',
            height: '100%',
            _after: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: 'none',
            },
        },
        heroBannerDesktop: {
            display: {base: 'none', md: 'none', lg: 'flex'},
            width: '100%',
        },
        heroBannerMobile: {display: {base: 'flex', md: 'flex', lg: 'none'}},
    },
}
